<template>
    <div style="height: 100%;overflow: auto;">
        <van-sticky>
            <div style="background-color: white;">
            <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
            <el-form :inline="true" class="demo-form-inline" size="mini" style="margin-top: 5px;background-color: #fff;text-align: center;">
              <el-form-item>
                <el-radio-group v-model="active" @change="activeChange">
                  <el-radio-button label="home">本月</el-radio-button>
                  <el-radio-button label="home1">上月</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </van-sticky>
        <el-table :data="examineData" height="calc(100% - 6.5rem)" style="width: 100%;font-size: 12px" :row-class-name="tableRowClassName"
        v-if="examineData.length>1"  @row-click="openTarger">
            <el-table-column fixed prop="storename" width="100" align="center" label="门店名称"></el-table-column>
            <el-table-column fixed prop="staffname" width="70" align="center" label="员工"></el-table-column>
            <el-table-column  prop="perf" label="业绩" align="center" width="120">
                <template slot-scope="scope">
                    {{scope.row.perf}}/{{scope.row.perftarger}}
                </template>
            </el-table-column>
            <!--<el-table-column  prop="number" label="成交" width="70" align="center"></el-table-column>-->
            <el-table-column  prop="newnumber" label="新客" width="70" align="center">
                <template slot-scope="scope">
                    {{scope.row.newnumber}}/{{scope.row.newtarger}}
                </template>
            </el-table-column>
            <el-table-column  prop="indibacount" label="indiba人数" align="center">
                <template slot-scope="scope">
                    {{scope.row.indibacount}}/{{$parseInt(scope.row.indibacount*0.85)}}
                </template>
            </el-table-column>
            <el-table-column  prop="indibadd" label="indiba到店" width="100" align="center">
                <template slot-scope="scope">
                    {{scope.row.indibadd}}({{$percentgae(scope.row.indibadd/scope.row.indibacount)}})
                </template>
            </el-table-column>
            <el-table-column  prop="indibaddcount" label="indiba到店次数" width="140" align="center">
                <template slot-scope="scope">
                    {{scope.row.indibaddcount}}/{{scope.row.indibacount*2}}
                </template>
            </el-table-column>
            <el-table-column  prop="bigdd" label="大顾客26人数" width="120" align="center"></el-table-column>
            <el-table-column  prop="bigcount" label="大顾客75次数" width="120" align="center"></el-table-column>
        </el-table>
        <el-descriptions v-else class="margin-top" :column="2"  border>
            <el-descriptions-item label="姓名">{{examineData[0].staffname}}</el-descriptions-item>
            <el-descriptions-item label="业绩">{{examineData[0].perf}}/{{examineData[0].perftarger}}</el-descriptions-item>
            <!--<el-descriptions-item label="成交人数">{{examineData[0].number}}</el-descriptions-item>-->
            <el-descriptions-item label="新客人数">{{examineData[0].newnumber}}/{{examineData[0].newtarger}}</el-descriptions-item>
            <el-descriptions-item label="indiba人数">{{examineData[0].indibacount}}/{{$parseInt(examineData[0].indibacount*0.85)}</el-descriptions-item>
            <el-descriptions-item label="indiba到店人数">{{examineData[0].indibadd}}({{$percentgae(examineData[0].indibadd/examineData[0].indibacount)}})</el-descriptions-item>
            <el-descriptions-item label="indiba到店次数">{{examineData[0].indibaddcount}}/{{examineData[0].indibacount*2}}</el-descriptions-item>
            <el-descriptions-item label="大顾客26人数">{{examineData[0].bigdd}}</el-descriptions-item>
            <el-descriptions-item label="大顾客75次数">{{examineData[0].bigcount}}</el-descriptions-item>
        </el-descriptions>
        <el-dialog :title="title" :visible.sync="dialogTableVisible" width="100%">
            <el-form @submit.native.prevent>
                <el-form-item label="新客目标">
                    <el-input placeholder="请输入内容" v-model="beautyExamineTarger.newnumber" type="number" clearable></el-input>
                </el-form-item>
                <el-form-item label="业绩目标">
                    <el-input placeholder="请输入内容" v-model="beautyExamineTarger.perf" type="number" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogTableVisible=false">取消</el-button>
                <el-button type="primary" size="mini" @click="saveBeautyExmineTarger()">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                curIndex:0,
                curData:{},
                dialogTableVisible:false,
                beautyExamineTarger:{},
                examineData:[],
                brands:[],
                active:"home",
                months:this.$moment().startOf('month').format('YYYY-MM'),
                title:this.$moment().startOf('month').format('MM')+"月",
                storeid:localStorage.getItem("parentstoreid"),
                fromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
                todate:this.$moment().endOf('month').format('YYYY-MM-DD'),
                staffid:localStorage.getItem("staffid"),
            }
        },
        created() {
            this.getBeautyExamine();
        },
        methods:{
            tableRowClassName({row, rowIndex}){
                row.index=rowIndex;
            },
            saveBeautyExmineTarger(){
                if(this.beautyExamineTarger.newnumber<1){
                    this.$message({message: "请输入新客目标",type: 'error'});
                    return;
                }
                if(this.beautyExamineTarger.newnumber<1){
                    this.$message({message: "请输入业绩目标",type: 'error'});
                    return;
                }
                this.beautyExamineTarger.storeid=this.curData.storeid;
                this.beautyExamineTarger.staffid=this.curData.staffid;
                this.beautyExamineTarger.months=this.months;
                this.$postw("beautymanager/saveBeautyExmineTarger",this.beautyExamineTarger).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.dialogTableVisible=false;
                        this.examineData[this.curIndex].newtarger=this.beautyExamineTarger.newnumber;
                        this.examineData[this.curIndex].perftarger=this.beautyExamineTarger.perf;
                        this.beautyExamineTarger.storeid="";
                        this.beautyExamineTarger.staffid="";
                        this.beautyExamineTarger.months="";
                        this.beautyExamineTarger.newnumber=0;
                        this.beautyExamineTarger.perf=0;
                    }
                    else{
                        this.$message({message: res.message,type: 'error'});
                    }
                });
            },
            openTarger(row,dfdf){
                let posid=localStorage.getItem("posid");
                if("07434c86082d482cb5e3a9a8a5b8dbe8"!=posid){
                    return;
                }
                this.curIndex=row.index;
                console.log(this.curIndex);
                this.curData=row;
                this.dialogTableVisible=true;
                this.getBeautyExamineTargerById(row);
            },
            getBeautyExamineTargerById(row){
                this.$post("beautymanager/getBeautyExamineTargerById",{storeid:row.storeid,staffid:row.staffid,months:this.months}).then(res=>{
                    if(res.sucess){
                        if(res.object!=null){
                            this.beautyExamineTarger=res.object;
                        }
                        else{
                            this.beautyExamineTarger={};
                        }
                    }
                    else{
                        this.$message({message: res.message,type: 'error'});
                    }
                });
            },
            activeChange(name){
                //console.log(name);
                if(name=="home"){
                    this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                    this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
                }
                else if(name=="home1"){
                    let dates=this.$lastMonth();
                    this.fromdate=dates[0];
                    this.todate=dates[1];
                }
                this.getBeautyExamine();
            },
            getBeautyExamine(){
                this.$post("beautymanager/getBeautyExamine",{storeid:this.storeid,staffid:this.staffid,fromdate:this.fromdate,todate:this.todate}).then(res=>{
                    if(res.sucess){
                        this.examineData=res.object;
                    }
                    else{
                        this.$message({message: res.message,type: 'error'});
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/beauty/beautyexamine.vue